import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface ProcessingSpinnerProps {
  message?: string;
  className?: string;
}

export function ProcessingSpinner({
  message = "Processing...",
  className,
}: ProcessingSpinnerProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-5 py-14",
        className
      )}
      role="status"
      aria-live="polite"
    >
      <div className="relative">
        <div className="absolute inset-0 rounded-full bg-primary/10 animate-pulse" />
        <Loader2
          className="size-12 animate-spin text-primary relative z-10"
          aria-hidden="true"
        />
      </div>
      {/* Sentence case, as written by the caller; the status region announces it once. */}
      <p className="max-w-sm text-center text-sm font-medium text-balance text-muted-foreground">
        {message}
      </p>
    </div>
  );
}

/*
 * Usage Example:
 *
 * import { ProcessingSpinner } from "@/components/processing-spinner";
 *
 * function ProcessingState() {
 *   return (
 *     <Card>
 *       <ProcessingSpinner message="Extracting tables from your PDF..." />
 *     </Card>
 *   );
 * }
 */
